import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Alert, AlertDescription, AlertTitle, Button } from '@brent/core-ui/ui'
import { X } from 'lucide-react'
import { useLiveQuestion } from '@/hooks/useQuestions'
import { useAuth } from '@/hooks/useAuth'

const DISMISS_KEY = 'vote-banner-dismissed'

export default function VoteBanner() {
  const { isAuthenticated, hasGroup } = useAuth()
  const isMember = isAuthenticated && hasGroup('member')
  const { data: question } = useLiveQuestion(isMember)
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === 'true')

  if (!isMember || !question || dismissed) {
    return null
  }

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, 'true')
    setDismissed(true)
  }

  return (
    <Alert className="mb-6 relative pr-12">
      <AlertTitle>Have your say!</AlertTitle>
      <AlertDescription className="flex flex-col sm:flex-row sm:items-center gap-2">
        <span className="flex-1">
          {question.statement.length > 100
            ? question.statement.slice(0, 100) + '...'
            : question.statement}
        </span>
        <Button asChild size="sm">
          <Link to="/voting">Vote now</Link>
        </Button>
      </AlertDescription>
      <button
        onClick={handleDismiss}
        className="absolute top-3 right-3 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100"
        aria-label="Dismiss voting banner"
      >
        <X className="h-4 w-4" />
      </button>
    </Alert>
  )
}
